import { CheckCircle, XCircle } from "lucide-react";

const ModelComparisonTable = () => {
  const features = [
    { name: "Display Size", rxt4d: "4\"", rxt4dv: "4\"", rxt6d: "6\"", rxt6dv: "6\"" },
    { name: "Resolution", rxt4d: "480×480", rxt4dv: "720×720", rxt6d: "1440×720", rxt6dv: "1440×720" },
    { name: "Brightness", rxt4d: "500 nits", rxt4dv: "500 nits", rxt6d: "500 nits", rxt6dv: "500 nits" },
    { name: "Processor", rxt4d: "Six Core 2.0GHz", rxt4dv: "Six Core 2.0GHz", rxt6d: "Six Core 2.0GHz", rxt6dv: "Six Core 2.0GHz" },
    { name: "Audio DSP", rxt4d: "800MHz", rxt4dv: "800MHz", rxt6d: "800MHz", rxt6dv: "800MHz" },
    { name: "ReAX™ Control System", rxt4d: true, rxt4dv: true, rxt6d: true, rxt6dv: true },
    { name: "Dante™/AES67 Audio", rxt4d: true, rxt4dv: true, rxt6d: true, rxt6dv: true },
    { name: "SmartSpeak™ Beamforming", rxt4d: true, rxt4dv: true, rxt6d: true, rxt6dv: true },
    { name: "WordGate™ Camera Tracking", rxt4d: true, rxt4dv: true, rxt6d: true, rxt6dv: true },
    { name: "VPX 1Gbps 4K60 AVoIP TX", rxt4d: false, rxt4dv: true, rxt6d: false, rxt6dv: true },
    { name: "RTSP Stream Support", rxt4d: true, rxt4dv: true, rxt6d: true, rxt6dv: true },
    { name: "USB-C & HDMI Inputs", rxt4d: false, rxt4dv: true, rxt6d: false, rxt6dv: true },
    { name: "USB-C 100W Pass-Through", rxt4d: false, rxt4dv: true, rxt6d: false, rxt6dv: true },
    { name: "USB-C Display Output", rxt4d: false, rxt4dv: true, rxt6d: false, rxt6dv: true },
    { name: "NFC", rxt4d: true, rxt4dv: true, rxt6d: true, rxt6dv: true },
    { name: "Speaker", rxt4d: "4W", rxt4dv: "4W", rxt6d: "4W", rxt6dv: "4W" },
    { name: "Network", rxt4d: "1G PoE+", rxt4dv: "1G PoE+", rxt6d: "1G PoE+", rxt6dv: "1G PoE+" },
    { name: "Form Factor", rxt4d: "Desktop", rxt4dv: "Desktop", rxt6d: "Desktop", rxt6dv: "Desktop" },
  ];

  const renderCell = (value: string | boolean) => {
    if (value === true) return <CheckCircle className="h-5 w-5 text-[#069E50] mx-auto" />;
    if (value === false) return <XCircle className="h-5 w-5 text-muted-foreground/30 mx-auto" />;
    return <span className="text-sm">{value}</span>;
  };

  return (
    <div className="mb-16">
      <h2 className="text-2xl font-bold mb-8">Model Comparison</h2>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse bg-card rounded-lg border shadow-sm">
          <thead>
            <tr className="border-b">
              <th className="text-left p-4 font-semibold">Feature</th>
              <th className="text-center p-4 font-semibold">
                <div>RXT-4-D</div>
                <div className="text-xs text-muted-foreground font-normal">4" Standard</div>
              </th>
              <th className="text-center p-4 font-semibold bg-[#069E50]/5">
                <div>RXT-4-DV</div>
                <div className="text-xs text-muted-foreground font-normal">4" + AVoIP</div>
              </th>
              <th className="text-center p-4 font-semibold">
                <div>RXT-6-D</div>
                <div className="text-xs text-muted-foreground font-normal">6" Standard</div>
              </th>
              <th className="text-center p-4 font-semibold bg-[#069E50]/5">
                <div>RXT-6-DV</div>
                <div className="text-xs text-muted-foreground font-normal">6" + AVoIP</div>
              </th>
            </tr>
          </thead>
          <tbody>
            {features.map((feature, index) => (
              <tr key={index} className={index % 2 === 0 ? "bg-muted/30" : ""}>
                <td className="p-4 text-sm font-medium">{feature.name}</td>
                <td className="p-4 text-center">{renderCell(feature.rxt4d)}</td>
                <td className="p-4 text-center bg-[#069E50]/5">{renderCell(feature.rxt4dv)}</td>
                <td className="p-4 text-center">{renderCell(feature.rxt6d)}</td>
                <td className="p-4 text-center bg-[#069E50]/5">{renderCell(feature.rxt6dv)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ModelComparisonTable;
